var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudCompute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2H22C13.8 2 9.7025 2 6.7975 4.035C5.7226 4.78767 4.78767 5.7226 4.035 6.7975C2 9.7 2 13.8 2 22C2 30.2 2 34.2975 4.035 37.2025C4.78767 38.2774 5.7226 39.2123 6.7975 39.965C9.7 42 13.8 42 22 42H32C40.2 42 44.2975 42 47.2025 39.965C48.2774 39.2123 49.2123 38.2774 49.965 37.2025C51.665 34.7775 51.945 31.5225 51.99 25.75",
    stroke: "#848484",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 34.5H29.5M27 42V52M17 52H37M29.5 13.6675C29.5 16.8875 32.0175 19.5 35.125 19.5H46.9375C49.7325 19.5 52 17.15 52 14.25C52 11.35 49.7075 9 46.9125 9C47.225 5.41 44.45 2 40.75 2C37.515 2 34.8575 4.575 34.585 7.86C31.7325 8.1425 29.5 10.635 29.5 13.6675Z",
    stroke: "#848484",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCompute);
export default __webpack_public_path__ + "static/media/cloud-compute.5ba6f075c612d12956af43b1f49ab484.svg";
export { ForwardRef as ReactComponent };